/* eslint-disable no-console */

import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import zhTWLocale from 'date-fns/locale/zh-TW';
import { ProvideAuth } from './utils/auth';
import { ProvideDialog } from './utils/dialog';
import { ProvideAPI } from './utils/api';
import CssBaseline from '@material-ui/core/CssBaseline';
import GlobalStyles from '@material-ui/core/GlobalStyles';
import { createTheme, ThemeProvider } from '@material-ui/core/styles';
import AdapterDateFns from '@material-ui/lab/AdapterDateFns';
import LocalizationProvider from '@material-ui/lab/LocalizationProvider';

import App from './views/app';
import reportWebVitals from './reportWebVitals';
import store from './redux/store';

import './utils/customScripts';

import './styles/main.scss';

const theme = createTheme({
  palette: {
    gray: {
      main: '#64748B',
      contrastText: '#fff',
    },
  },
});

const root = document.querySelector('#react-app-root');

ReactDOM.render(
  <React.StrictMode>
    <CssBaseline />
    <GlobalStyles />
    <Provider store={store}>
      <Router>
        <ProvideDialog>
          <ProvideAPI>
            <ProvideAuth>
              <ThemeProvider theme={theme}>
                <LocalizationProvider
                  dateAdapter={AdapterDateFns}
                  locale={zhTWLocale}
                >
                  <App />
                </LocalizationProvider>
              </ThemeProvider>
            </ProvideAuth>
          </ProvideAPI>
        </ProvideDialog>
      </Router>
    </Provider>
  </React.StrictMode>,
  root
);

const DEBUG_ENABLED = process.env.REACT_APP_USE_DEBUG === 'true';
const MOCK_ENABLED = process.env.REACT_APP_USE_MOCK === 'true';

if (!DEBUG_ENABLED) {
  const emptyFunciton = () => {};
  // console.debug = emptyFunciton;
  // console.info = emptyFunciton;
  // console.log = emptyFunciton;
  // console.warn = emptyFunciton;
  // console.error = emptyFunciton;
  window.alert = emptyFunciton;
}

if (MOCK_ENABLED) {
  console.log('App is in mock mode.');
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
